import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import "./Chatbot.css";

const Chatbot = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [isChatboxOpen, setIsChatboxOpen] = useState(false);
  const [welcomeMessage, setWelcomeMessage] = useState(
    "Welcome to our Aram Eye Care! How can I help you today?"
  );

  const handleChatboxToggle = () => {
    setIsChatboxOpen(!isChatboxOpen);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!input) return;

    const newMessage = { text: input, sender: "user" };
    setMessages([...messages, newMessage]);
    setInput("");
    setLoading(true);

    try {
      const response = await fetch("http://46.202.166.215:5002/ask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ question: input }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessages((prevMessages) => [
          ...prevMessages,
          { text: data.answer, sender: "bot" },
        ]);
      } else {
        setMessages((prevMessages) => [
          ...prevMessages,
          { text: data.error || "Something went wrong", sender: "bot" },
        ]);
      }
    } catch (error) {
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: "Error connecting to server", sender: "bot" },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {!isChatboxOpen && (
        <div className="chatbot-toggle" onClick={handleChatboxToggle}>
          <div className="cloud-background">
            <span role="img" aria-label="glass">🕶</span>
          </div>
        </div>
      )}
      {isChatboxOpen && (
        <div className="chatbot-container open">
          <div className="chatbot">
            <div className="chatbot-header">
              <h2>ChatMate</h2>
              <AiOutlineClose
                className="close-icon"
                onClick={handleChatboxToggle}
              />
            </div>
            <div className="chatbot-messages">
              <div className="welcome-message">{welcomeMessage}</div>
              {messages.map((message, index) => (
                <div key={index} className={`chatbot-message ${message.sender}`}>
                  {message.text}
                </div>
              ))}
            </div>
            <form className="chatbot-input" onSubmit={handleSubmit}>
              <div className="input-box-container">
                <input
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Type a message..."
                  disabled={loading}
                />
                <button type="submit" disabled={loading}>
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot;